import getIdentifier from 'getIdentifier';

// A Table's field column: each row's latest value of a text field from the
// table's dataset (e.g. a driver's code beside their miles). It's a
// single-use metric aggregating the field with 'last', which the matrix
// already draws as text (left-aligned, never coloured or ranked); the
// column's options mark it so the table doesn't total, compare or sort by it
// (see buildTableDefinition).

export const isFieldColumn = (
  options: Studio.TableMetricOptions | undefined,
): boolean => !!options && !!options.isFieldColumn;

export const buildFieldColumnMetric = ({
  dataType,
  field,
  name,
  userId,
  now,
}: {
  dataType: string;
  field: string;
  // The field's label, as the column's header
  name: string;
  userId: string;
  now: string;
}): Metrics.SingleUseMetric => ({
  id: getIdentifier(),
  type: 'normal',
  name,
  description: `Latest ${name}`,
  dataType,
  field,
  aggFunc: 'last',
  filters: {},
  formatting: {},
  status: 'single use',
  createdBy: userId,
  createdOn: now,
  updatedBy: userId,
  updatedOn: now,
});

// The fields a field column can show: text fields the dataset can take the
// latest value of, other than the table's dimensions and its field columns
export const getFieldColumnFields = ({
  fields,
  excludedFields,
}: {
  fields: FleetOps.Field[];
  excludedFields: string[];
}): FleetOps.Field[] =>
  fields.filter(
    (f) =>
      f.type === 'text' &&
      f.aggFuncs.includes('last') &&
      !excludedFields.includes(f.field),
  );
